import Data from "../data.yml";

export default Data;

export function isGameReleased() {
  var releaseDay = new Date(Date.UTC(2020, 3, 17, 6, 0, 0));
  return releaseDay < new Date();
}
